import { DialogData } from '../model/dialogData';
import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {searchModule}from '../../../../assets/conf_urls.json';

@Injectable()
export class SearchService{
  /**
   *Service used to fetch the searched result based on the key and the value.
   */
  constructor(public http:HttpClient) {
  }

  postSearchData(selectedKey:string,searchText:string):Observable<DialogData[]>{

    return this.http.post<DialogData[]>(searchModule.postSearch,{
                    "event" : "select_by_key",
                    "search_key" : selectedKey,
                    "search_value" : searchText
                }
     );

  }

}
